export default __webpack_public_path__ + "static/media/united-states.bf2fd217.svg";